import {
  selectAllFilteredSelected,
  selectHasCurrentTotalCount,
  type EagGridStore,
} from '../store/createEagGridStore';
import type {
  BulkOperationSelection,
  BulkOperationSelectionSource,
} from '../types/BulkOperationActionCallback';

/** Reads the grid synchronously, including changes made before React commits. */
export function createBulkOperationSelectionSource(
  store: EagGridStore
): BulkOperationSelectionSource {
  let previous = store.getState();
  let snapshot: BulkOperationSelection = {
    recordIds: [...previous.selectedRowIds],
    query: {state: 'unavailable', dataQueryId: null},
  };
  const getSnapshot = () => {
    const state = store.getState();
    const hasCurrentCount = selectHasCurrentTotalCount(state);
    const ready = state.fetchState === 'success' && hasCurrentCount && state.queryId !== '';
    const dataQueryId = state.queryId === '' ? null : state.queryId;
    const totalCount = hasCurrentCount ? state.totalCount : undefined;
    const allFilteredSelected = selectAllFilteredSelected(state);
    if (
      snapshot.query.dataQueryId !== dataQueryId ||
      (snapshot.query.state === 'ready') !== ready ||
      snapshot.query.totalCount !== totalCount ||
      snapshot.allFilteredSelected !== allFilteredSelected ||
      previous.selectedRowIds !== state.selectedRowIds
    ) {
      snapshot = {
        recordIds: [...state.selectedRowIds],
        query: ready
          ? {state: 'ready', dataQueryId: state.queryId, totalCount: state.totalCount}
          : {state: 'unavailable', dataQueryId, totalCount},
        allFilteredSelected,
      };
    }
    previous = state;
    return snapshot;
  };
  getSnapshot();
  return {
    getSnapshot,
    subscribe: (listener) => {
      let observedSnapshot = getSnapshot();
      return store.subscribe(() => {
        const nextSnapshot = getSnapshot();
        if (nextSnapshot !== observedSnapshot) {
          observedSnapshot = nextSnapshot;
          listener();
        }
      });
    },
  };
}
